<template>
</template>
<script>
    export default {
        name: "ListItemElement",
        data() {
            return {
                elementType: 'listItem'
            }
        },
    }
</script>
